import Vue from 'vue'
import * as types from '../mutation-types'
import { getAccountId } from '@/util/accountUtil'
import accountApi from '@/api/account'
import debounce from 'lodash/debounce'
import { snapshotDoc } from '../../util/firestoreUtil'

const MUTA = {
  // This is not deterministic state. Requires asynchronous coordination with backend.
  isRefreshingClaims: 'isRefreshingClaims',
  updateClaims: 'updateClaims',
  accountAlerts: 'accountAlerts'
}

let _debounceRefreshingClaims
const debounceRefreshingClaims = commit => {
  if (!_debounceRefreshingClaims) {
    _debounceRefreshingClaims = debounce(() => {
      commit(MUTA.isRefreshingClaims, false)
    }, 1000)
  }
  _debounceRefreshingClaims()
}

const initialState = {
  isAuthenticated: false,
  idTokenClaims: { isLoaded: false },
  isRefreshingClaims: false,
  accountPreferences: { }
}

const moduleGetters = {
  isAuthenticated: s => s.isAuthenticated,
  accountId: s => _ => getAccountId(),
  isAccountLoaded: s => s.idTokenClaims.isLoaded,
  accountPictureUrl: s => s.idTokenClaims.picture,
  isAccountPaid: s => s.idTokenClaims.paid,
  accountAccess: s => ({
    npe: s.idTokenClaims.npeax,
    time: s.idTokenClaims.timeax
  }),
  accountPreferences: s => s.accountPreferences
}

// actions
const actions = {
  updateAccount ({ commit }, account) {
    // Do not commit account to the store, it will cause an infinite loop for some reason (20180406)
    commit(types.IS_AUTHENTICATED, !!account)
  },
  async queryIdTokenClaims ({ commit }) {
    commit(MUTA.isRefreshingClaims, true)
    await accountApi.updateIdTokenClaims()
    // Async callback. Further action here not necessary.
  },
  updateIdTokenClaims ({ commit }, claims) {
    commit(MUTA.updateClaims, claims)

    debounceRefreshingClaims(commit)
  },
  async queryAccountAlerts ({ state, commit }, force) {
    if (!force && state.accountPreferences.alerts) { return }

    const accountId = getAccountId()
    if (!accountId) { return }

    try {
      const alertSnap = await snapshotDoc(`account/${accountId}/account-preferences/account-alerts`)
      const alertData = alertSnap.exists() ? alertSnap.data() : {}
      commit(MUTA.accountAlerts, alertData.exin)
    } catch (e) {
      Vue.logger.error(e)
    }
  }
}

// mutations
const mutations = {
  [types.IS_AUTHENTICATED] (s, isAuthenticated) {
    s.isAuthenticated = isAuthenticated
  },
  [MUTA.isRefreshingClaims] (s, b) {
    s.isRefreshingClaims = b
  },
  [MUTA.updateClaims] (s, claims) {
    const { picture, paid, npeax, timeax } = (claims || {})
    const isLoaded = Object.keys(claims).length > 0
    s.idTokenClaims = { isLoaded, picture, paid, npeax, timeax }
  },
  [MUTA.accountAlerts] (s, alerts) {
    // TODO Set so obeservers are notified
    s.accountPreferences.alerts = alerts
  }
}

export default {
  state: initialState,
  getters: moduleGetters,
  actions,
  mutations
}
